import AuthorizationPage from './authorizationPage';
export default AuthorizationPage;
